// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/studentClasses.css
// module id = 869
// module chunks = 41